export default __webpack_public_path__ + "static/media/holistica.5b9de8d2.jpg";